import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  BtnClose, Dialog, DialogContent, DialogTitle,
  Line, MLabel, Overlay,
  TextContent,
  TextTile,
  InputText,
  TextArea,
  VisuallyHiddenInput
} from './styles'
import { Box, Button, FormControl, MenuItem, Select, Stack, } from "@mui/material";
import { INV_GOODS_UNIT, MESSAGE } from "Common";
import inventoryApi from "api/inventoryApi";
import { CompressImage } from "Compress";

const DialogEditInvGoods = ({ invGoods, handleClose, setIsLoading, setReload, setMessage }) => {
  const [gName, setGName] = useState("");
  const [gSize, setGSize] = useState("");
  const [stockQMemo, setStockQMemo] = useState("");
  const [shelfName, setShelfName] = useState("");
  const [invGoodsMemo, setInvGoodsMemo] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    if (!invGoods?.ClientInventoryGoodsID) return;
    setGName(invGoods.GoodsName);
    setGSize(invGoods.GoodsSize);
    setStockQMemo(invGoods.StockQMemo);
    setShelfName(invGoods.ShelfName || "");
    setInvGoodsMemo(invGoods.ClientInventoryGoodsMemo || "");
    setImgUrl(invGoods.ImageUrl1 || "");
    setImgSrc(null);
  }, [invGoods])

  const handleUploadImage = async (target) => {
    if (!target.files || target.files.length !== 1) return;
    try {
      setIsLoading(true);
      const uploadedFile = Array.from(target.files)[0];
      const compressedFiles = await CompressImage(uploadedFile);
      setImgSrc(compressedFiles);
    } catch (error) {
      const msg = { type: MESSAGE.ERROR, contents: [error.toString()] };
      setMessage(msg);
    } finally {
      setIsLoading(false);
    }
  }

  const handleDialogClose = () => {
    setGName("");
    setGSize("");
    setStockQMemo("");
    setShelfName("");
    setInvGoodsMemo("");
    setImgUrl("");
    setImgSrc(null);
    handleClose();
  }

  const handleSave = async () => {
    //登録処理
    try {
      //Validate
      //gName, gSize
      if (!gName || !gSize) {
        const msg = {
          contents: ['必須項目を入力してください。', '「商品名」・「サイズ」は必須項目です。'],
          type: MESSAGE.ERROR
        }
        setMessage(msg);
        return;
      }

      setIsLoading(true);
      /**Call Api */
      const formData = new FormData();
      formData.append("invId", invGoods.ClientInventoryGoodsID);
      formData.append("gName", gName)
      formData.append("gSize", gSize)
      formData.append("stkQMemo", stockQMemo || '')
      formData.append("shfName", shelfName || '')
      formData.append("invGMemo", invGoodsMemo || '')
      formData.append("imgUrl", imgUrl || '')
      formData.append("gImgFile[]", imgSrc?.file || null)
      const dtResponse = await inventoryApi.updateInvGoods(formData);
      const invGoodsID = parseInt(dtResponse?.data['invGoodsID'] ?? 0);
      if (invGoodsID < 1) {
        throw new Error('在庫データの変更が失敗しました');
      }

      const msg = {
        contents: ['在庫データの変更が成功しました'],
        type: MESSAGE.INFO,
        handleClose: () => {
          setReload(prev => !prev); //reload
          handleDialogClose();
        }
      }
      setMessage(msg);
    } catch (error) {
      const msg = {
        contents: [error],
        type: MESSAGE.ERROR
      }
      setMessage(msg);
    } finally {
      setIsLoading(false);
    }

  }

  return <>
    {invGoods?.ClientInventoryGoodsID && (<>
      <Dialog>
        <DialogTitle>
          <TextTile>{"在庫データ編集"}</TextTile>
          <BtnClose onClick={() => { handleDialogClose(); }}><FontAwesomeIcon icon={faXmark} /></BtnClose>
        </DialogTitle>
        <DialogContent>
          <TextContent>
            <Line column>
              <MLabel>商品名<span style={{ color: "#f00" }}>*</span>：</MLabel>
              <InputText
                maxLength={64}
                // placeholder={'商品名'}
                value={gName}
                onChange={(e) => { setGName(e.target.value); }}
              />

            </Line>

            <Line column>
              <MLabel>サイズ<span style={{ color: "#f00" }}>*</span>：</MLabel>
              <InputText
                maxLength={12}
                width={'120px'}
                // placeholder={'サイズ'}
                value={gSize}
                onChange={(e) => { setGSize(e.target.value); }}
              />
            </Line>
            <Line column>
              <MLabel>単位：</MLabel>
              <FormControl sx={{ minWidth: 60, }} size="small">
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={stockQMemo}
                  onChange={(e) => { setStockQMemo(e.target.value) }}
                  sx={{
                    height: 28, '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'gray',
                    },
                    ml: 1,
                    width: "120px"
                  }}
                >
                  <MenuItem value={""}></MenuItem>
                  {INV_GOODS_UNIT.map((unit, index) => (
                    <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Line>
            <Line column>
              <MLabel>保存場所：</MLabel>
              <InputText
                maxLength={50}
                // placeholder={'保存場所'}
                value={shelfName}
                onChange={(e) => { setShelfName(e.target.value) }}
              />
            </Line>
            <Line column>
              <MLabel>在庫メモ：</MLabel>
              <TextArea
                maxLength={200}
                rows={2}
                value={invGoodsMemo}
                onChange={(e) => { setInvGoodsMemo(e.target.value); }}
              />
            </Line>

            <Line >
              <MLabel>商品画像：</MLabel>
              <Button component="label" variant="outlined" size="small" sx={{ minWidth: "50px" }}>選択
                <VisuallyHiddenInput type="file"
                  accept="image/*"
                  value={""}
                  onChange={(event) => { handleUploadImage(event.target) }}
                />
              </Button>
              {(!!imgSrc?.url) && (<Button variant="outlined" size="small" color="secondary"
                sx={{ minWidth: "50px", ml: 1 }} onClick={() => { setImgSrc(null); }}>削除</Button>)}
            </Line>
            <Box sx={{ width: "100%", textAlign: "center", mt: 0.5 }}>
              {(!!imgSrc?.url || !!imgUrl) && (<Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box component={"img"}
                  sx={{ height: 80, width: "auto", mb: 1 }}
                  alt='商品画像' src={imgSrc?.url || imgUrl} />
              </Box>)}
            </Box>
          </TextContent>

          <Stack direction="row" spacing={2} mt={1}  >
            <Button variant="outlined" color="secondary" onClick={() => { handleDialogClose() }}>キャンセル</Button>
            <Button variant="contained" color="primary" sx={{ minWidth: "100px" }} onClick={() => { handleSave(); }}
            >変更</Button>
          </Stack>
        </DialogContent>
      </Dialog>
      <Overlay /></>)
    }
  </>;
};

export default DialogEditInvGoods
